import Link from 'next/link';
import type { ReactNode } from 'react';

export function CmsEditorialLink({
  href,
  children,
  className,
}: {
  href?: string | null;
  children: ReactNode;
  className?: string;
}) {
  const normalizedHref = href?.trim() ?? '';

  if (!normalizedHref) {
    return null;
  }

  return (
    <Link href={normalizedHref} className={className}>
      {children}
    </Link>
  );
}
